import { useEffect, useRef, useState } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import LayoutSubmaster from "../../components/layoutSubmasterConfig/layoutSubmaster"
import { Zip_Code_Api } from "../../services/zip_code_api/zip_code_api";
import { apiClientSubmaster } from "../../services/setupClientSubmaster/apiClientSubmaster";
import { toast } from "react-toastify";
import LocalStorage from "../../helpers/localstorage";
import axios from "axios";
import edit from '../../components/dashboard/img/favicon/editar.png';
import {
    createSimplePdfBlob,
    downloadBlob,
    formatDateForFileName,
    runPdfOnlyBackup,
    sanitizeFileName,
} from "../../helpers/backupExport";


function ConfigSubmasterEmployeesPage(){

    const marginFilter = { marginLeft: "-0.3%"};

    let localStorage = new LocalStorage()
    const submasterId = Number(localStorage.getId() ?? 0);
    const canEmployeeCreate = localStorage.hasWebPermission("canEmployeeCreate");
    const canEmployeeEdit = localStorage.hasWebPermission("canEmployeeEdit");
    const canEmployeeDelete = localStorage.hasWebPermission("canEmployeeDelete");

    const [showFormupdateEmployess ,setShowFormupdateEmployess] = useState(false);
    const [showFormCreateEmployess ,setShowFormCreateEmployess] = useState(false);

    type CompanyOption = {
        id: number;
        name: string;
        cnpj: string;
        image: string;
    };

    type DataRow = {
        id: number;
        name: string;
        email: string;
        address: string;
        cpf: string;
        neighborhood: string;
        postal_code: string;
        city: string;
        state: string;
        number: string;
        house_number: string;
        department: string;
        signature: string;
        biometric_data: string;
        submasterId: number; 
        companyId: number;
        companyName: string;
        companyCnpj: string;
        companyImage: string;
        employeeposition:string;
        admission_date:string;
        activeemployee: boolean
    };

    type EmployeeFormData = {
        id: number;
        name: string;
        email: string;
        cpf: string;
        address: string;
        neighborhood: string;
        postal_code: string;
        city: string;
        state: string;
        number: string;
        house_number: string;
        department: string;
        submasterId: number;
        companyId: number;
        companyName: string;
        companyCnpj: string;
        companyImage: string;
        admission_date: string;
        employeeposition: string;
        activeemployee:boolean
    };

    const getDefaultFormData = (): EmployeeFormData => ({
        id: 0,
        name: "",
        email: "",
        cpf: "",
        address: "",
        neighborhood: "",
        postal_code: "",
        city: "",
        state: "",
        number: "",
        house_number: "",
        department: "",
        submasterId: submasterId,
        companyId: submasterId,
        companyName: "",
        companyCnpj: "",
        companyImage: "",
        admission_date: "",
        employeeposition: "",
        activeemployee: true
    });
      
    const resetData = () => {
        setFormData(getDefaultFormData())
    }


    const [getData, setgetData] = useState<DataRow[]>([]);
    const [masterDataDeleteEnabled, setMasterDataDeleteEnabled] = useState(false);
    const [deletingEmployeeId, setDeletingEmployeeId] = useState<number | null>(null);
    const [showEmployeesFormUpdate ,setShowEmployeesFormUpdate ] = useState(false);
    
    const [formData, setFormData] = useState<EmployeeFormData>(getDefaultFormData());
    const [signaturePhotoAllowed, setSignaturePhotoAllowed] = useState(false);
    const [fixedSignatureAllowed, setFixedSignatureAllowed] = useState(false);
    const [signaturePhotoFile, setSignaturePhotoFile] = useState<File | null>(null);
    const [selectedPhotoUrl, setSelectedPhotoUrl] = useState<string | null>(null);
    const [savedPhotoUrl, setSavedPhotoUrl] = useState<string | null>(null);
    const [savedPhotoExtension, setSavedPhotoExtension] = useState("png");
    const photoRequestId = useRef(0);
    const cameraStreamRef = useRef<MediaStream | null>(null);
    const cameraRequestId = useRef(0);
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const [cameraOpen, setCameraOpen] = useState(false);

    const stopSignatureCamera = () => {
        cameraRequestId.current += 1;
        cameraStreamRef.current?.getTracks().forEach((track) => track.stop());
        cameraStreamRef.current = null;
        setCameraOpen(false);
    };

    useEffect(() => () => {
        cameraRequestId.current += 1;
        photoRequestId.current += 1;
        cameraStreamRef.current?.getTracks().forEach((track) => track.stop());
    }, []);

    useEffect(() => {
        if (cameraOpen && videoRef.current && cameraStreamRef.current) {
            videoRef.current.srcObject = cameraStreamRef.current;
            void videoRef.current.play().catch(() => {});
        }
    }, [cameraOpen]);

    const openSignatureCamera = async () => {
        if (!navigator.mediaDevices?.getUserMedia) {
            toast.error("Câmera indisponível neste dispositivo. Selecione uma foto.");
            return;
        }
        try {
            stopSignatureCamera();
            const requestId = ++cameraRequestId.current;
            const stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: { ideal: "environment" } },
                audio: false,
            });
            if (requestId !== cameraRequestId.current) {
                stream.getTracks().forEach((track) => track.stop());
                return;
            }
            cameraStreamRef.current = stream;
            setCameraOpen(true);
        } catch (error) {
            toast.error("Não foi possível abrir a câmera. Verifique a permissão do navegador.");
        }
    };

    const captureSignaturePhoto = () => {
        const video = videoRef.current;
        if (!video?.videoWidth || !video.videoHeight) {
            toast.error("Aguarde a câmera carregar antes de tirar a foto.");
            return;
        }
        const canvas = document.createElement("canvas");
        const scale = Math.min(1, 1600 / video.videoWidth);
        canvas.width = Math.round(video.videoWidth * scale);
        canvas.height = Math.round(video.videoHeight * scale);
        const context = canvas.getContext("2d");
        if (!context) {
            toast.error("Não foi possível processar a foto da câmera.");
            return;
        }
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
            if (!blob || blob.size > 5 * 1024 * 1024) {
                toast.error("Não foi possível registrar a foto. Tente novamente.");
                return;
            }
            setSignaturePhotoFile(new File([blob], "assinatura-funcionario.jpg", { type: "image/jpeg" }));
            stopSignatureCamera();
        }, "image/jpeg", 0.85);
    };

    useEffect(() => {
        if (!signaturePhotoFile) {
            setSelectedPhotoUrl(null);
            return;
        }
        const url = URL.createObjectURL(signaturePhotoFile);
        setSelectedPhotoUrl(url);
        return () => URL.revokeObjectURL(url);
    }, [signaturePhotoFile]);

    useEffect(() => () => {
        if (savedPhotoUrl) URL.revokeObjectURL(savedPhotoUrl);
    }, [savedPhotoUrl]);

    const handleSignaturePhotoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        stopSignatureCamera();
        const file = event.target.files?.[0] || null;
        event.target.value = "";
        if (file && (!["image/jpeg", "image/png", "image/webp"].includes(file.type) || file.size > 5 * 1024 * 1024)) {
            toast.error("Selecione uma foto JPG, PNG ou WebP de até 5 MB.");
            return;
        }
        setSignaturePhotoFile(file);
    };

    const uploadSignaturePhoto = async (employeeId: number) => {
        if (!signaturePhotoFile) return;
        const photoData = new FormData();
        photoData.append("photo", signaturePhotoFile);
        const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
        const response = await ApiClient.post(`/employeeSignaturePhoto/${employeeId}`, photoData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        if (!response?.data?.res) throw new Error("Não foi possível salvar a foto da assinatura.");
    };

    const loadSavedSignaturePhoto = async (employeeId: number, requestId: number) => {
        try {
            const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
            const response = await ApiClient.get(`/employeeSignaturePhoto/${employeeId}`, {
                responseType: "blob",
            });
            if (photoRequestId.current === requestId && response?.status === 200 && response.data instanceof Blob) {
                setSavedPhotoExtension(response.data.type === "image/jpeg" ? "jpg" : response.data.type === "image/webp" ? "webp" : "png");
                setSavedPhotoUrl(URL.createObjectURL(response.data));
            }
        } catch (error) {
            console.error("Erro ao consultar foto da assinatura do funcionário:", error);
        }
    };

    useEffect(() => {
        if (!(signaturePhotoAllowed || fixedSignatureAllowed) || !showEmployeesFormUpdate || !formData.id) return;
        const requestId = ++photoRequestId.current;
        setSavedPhotoUrl(null);
        void loadSavedSignaturePhoto(formData.id, requestId);
        return () => { photoRequestId.current += 1; };
    }, [signaturePhotoAllowed, fixedSignatureAllowed, showEmployeesFormUpdate, formData.id]);

    const renderSignaturePhotoField = (inputId: string, showSavedPhoto: boolean) => (
        (signaturePhotoAllowed || (showSavedPhoto && fixedSignatureAllowed)) ? (
            <div className="mb-3">
                <label htmlFor={signaturePhotoAllowed ? inputId : undefined} className="form-label fw-semibold">Foto ou Assinatura</label>
                {signaturePhotoAllowed && <>
                <input
                    id={inputId}
                    type="file"
                    accept="image/jpeg,image/png,image/webp"
                    capture="environment"
                    className="form-control"
                    onChange={handleSignaturePhotoChange}
                />
                <small className="text-muted">Tire uma foto da assinatura do funcionário ou selecione uma imagem (até 5 MB).</small>
                <div className="mt-2">
                    <button type="button" className="btn btn-outline-primary" onClick={openSignatureCamera}>
                        <i className="bi bi-camera me-1" /> Abrir câmera
                    </button>
                </div>
                </>}
                {!signaturePhotoAllowed && fixedSignatureAllowed && (
                    <small className="d-block text-muted">A assinatura pode ser registrada pelo aplicativo e baixada aqui.</small>
                )}
                {cameraOpen && (
                    <div className="mt-2">
                        <video ref={videoRef} autoPlay playsInline muted className="d-block rounded border" style={{ maxWidth: "100%", maxHeight: "280px" }} />
                        <div className="d-flex flex-wrap gap-2 mt-2">
                            <button type="button" className="btn btn-primary" onClick={captureSignaturePhoto}>Tirar foto</button>
                            <button type="button" className="btn btn-outline-secondary" onClick={stopSignatureCamera}>Fechar câmera</button>
                        </div>
                    </div>
                )}
                {(selectedPhotoUrl || (showSavedPhoto && savedPhotoUrl)) && (
                    <div className="d-flex flex-column align-items-start gap-2 mt-2">
                        <img
                            src={selectedPhotoUrl || savedPhotoUrl || undefined}
                            alt="Foto da assinatura do funcionário"
                            className="img-thumbnail"
                            style={{ maxWidth: "280px", maxHeight: "180px", objectFit: "contain" }}
                        />
                        {signaturePhotoFile && (
                            <button type="button" className="btn btn-outline-secondary" onClick={() => setSignaturePhotoFile(null)}>
                                Cancelar nova foto
                            </button>
                        )}
                        {showSavedPhoto && savedPhotoUrl && !signaturePhotoFile && (
                            <a className="btn btn-outline-primary" href={savedPhotoUrl} download={`assinatura-funcionario-${formData.id}.${savedPhotoExtension}`}>
                                <i className="bi bi-download me-1" /> Baixar foto ou assinatura
                            </a>
                        )}
                    </div>
                )}
            </div>
        ) : null
    );

    const [companies, setCompanies] = useState<CompanyOption[]>([]);
    const [loggedCompanyName, setLoggedCompanyName] = useState(String(localStorage.getName() ?? ""));

    const normalizeCompanies = (payload: any): CompanyOption[] => {
        const items = Array.isArray(payload)
            ? payload
            : Array.isArray(payload?.data)
                ? payload.data
                : [];

        return items.map((item: any) => ({
            id: Number(item?.id ?? item?.companyId ?? item?.company_id ?? 0),
            name: String(item?.name_company ?? item?.nameCompany ?? item?.name ?? ""),
            cnpj: String(item?.cnpj ?? ""),
            image: String(item?.image ?? item?.logo ?? item?.image_company ?? ""),
        })).filter((company: CompanyOption) => company.id > 0);
    };

    const getSelectedCompanyId = () => Number(formData.companyId || submasterId);
    const getSelectedCompanyPayload = () => {
        const selectedCompanyId = getSelectedCompanyId();

        if (selectedCompanyId === submasterId) {
            return {
                submasterCompanyId: null,
                name_company: null,
                cnpj_company: null,
                image_company: null,
            };
        }

        const selectedCompany = companies.find((company) => company.id === selectedCompanyId);

        return {
            submasterCompanyId: selectedCompanyId,
            name_company: selectedCompany?.name ?? formData.companyName ?? "",
            cnpj_company: selectedCompany?.cnpj ?? formData.companyCnpj ?? "",
            image_company: selectedCompany?.image ?? formData.companyImage ?? "",
        };
    };

    const getLoggedCompanyName = () =>
        loggedCompanyName.trim() || String(localStorage.getName() ?? "").trim() || "Empresa logada";

    const isDefaultCompanyLabel = (companyName?: string) => {
        const normalizedName = String(companyName ?? "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .trim()
            .toLowerCase();

        return normalizedName === "empresa padrao";
    };

    const getCompanyName = (companyId?: number) => {
        const selectedCompanyId = Number(companyId || submasterId);

        if (selectedCompanyId === submasterId) {
            return getLoggedCompanyName();
        }

        return companies.find((company) => company.id === selectedCompanyId)?.name ?? "Empresa vinculada";
    };

    const getCompanyTableName = (row: DataRow) => {
        const rowCompanyName = row.companyName?.trim() ?? "";

        if (rowCompanyName && !isDefaultCompanyLabel(rowCompanyName)) {
            return rowCompanyName;
        }

        return getCompanyName(row.companyId);
    };

    const sortEmployeesAlphabetically = (rows: DataRow[]) =>
        [...rows].sort((firstEmployee, secondEmployee) =>
            firstEmployee.name.localeCompare(secondEmployee.name, "pt-BR", {
                sensitivity: "base",
                ignorePunctuation: true,
            })
        );

    const handleCompanyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedCompanyId = Number(e.target.value || submasterId);
        const selectedCompany = companies.find((company) => company.id === selectedCompanyId);

        setFormData({
            ...formData,
            companyId: selectedCompanyId,
            companyName: selectedCompany?.name ?? "",
            companyCnpj: selectedCompany?.cnpj ?? "",
            companyImage: selectedCompany?.image ?? "",
        });
    };

    const handleGetCompanies = async () => {
        try {
            const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
            const data = new FormData();

            data.append("submaster_id", String(submasterId));
            data.append("action", "list");

            const response: any = await ApiClient.post(
                `/crud/companyForSubmaster/submaster_company/${submasterId}`,
                data,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response?.status >= 200 && response?.status < 300) {
                setCompanies(normalizeCompanies(response.data));
            }
        } catch (error) {
            toast.error("Erro ao buscar empresas.");
        }
    };

    const handleGetLoggedCompanyName = async () => {
        try {
            const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
            const response = await ApiClient.post(`/crud/getdata/Submaster/${submasterId}/true`);
            const payload = Array.isArray(response.data)
                ? response.data[0]
                : Array.isArray(response.data?.data)
                    ? response.data.data[0]
                    : response.data;
            const companyName = String(payload?.fantasy_name ?? payload?.name ?? localStorage.getName() ?? "").trim();

            if (companyName) {
                setLoggedCompanyName(companyName);
            }
        } catch (error) {
            setLoggedCompanyName(String(localStorage.getName() ?? ""));
        }
    };
      
      
    const formatCpfCustom = (value: string) => {
        return value
        .replace(/\D/g, '') // Remove tudo que não for número
        .replace(/^(\d{3})(\d{3})(\d{3})(\d{2}).*/, '$1.$2.$3-$4'); // Aplica a máscara
    };
      

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
      
        let formattedValue = value;
      
        if (name === 'cpf') {
          formattedValue = formatCpfCustom(value);
        }
      
        setFormData({
          ...formData,
          [name]: formattedValue,
        });
    };
      
    const customStyles = {
  header: {
    style: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#0d6efd',
    },
  },
  headRow: {
    style: {
      backgroundColor: '#f8f9fa',
      borderBottom: '1px solid #dee2e6',
    },
  },
  headCells: {
    style: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#495057',
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  rows: {
    style: {
      minHeight: '50px', // altura mínima da linha
      fontSize: '14px',
      '&:hover': {
        backgroundColor: '#e9f5ff', // destaque ao passar o mouse
      },
    },
  },
  cells: {
    style: {
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  pagination: {
    style: {
      borderTop: '1px solid #dee2e6',
      paddingTop: '8px',
      fontSize: '14px',
    },
  },
};

 const handleDeleteEmployee = async (row: DataRow) => {
    if (deletingEmployeeId !== null) return;
    if (!window.confirm(`Deseja excluir o funcionário ${row.name}? Esta ação não pode ser desfeita.`)) return;

    try {
      setDeletingEmployeeId(row.id);
      const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
      const response = await ApiClient.post(
        `/crud/delete/EmployeesSubmaster/${row.id}/${submasterId}`
      );
      if (!response?.data?.res) {
        toast.warning(response?.data?.message || "Não foi possível excluir o funcionário.");
        return;
      }
      setgetData((current) => current.filter((item) => item.id !== row.id));
      toast.success("Funcionário excluído com sucesso.");
    } catch (error) {
      const message = axios.isAxiosError(error)
        ? error.response?.data?.message
        : null;
      toast.warning(message || "Não foi possível excluir o funcionário.");
    } finally {
      setDeletingEmployeeId(null);
    }
 };

 const columns: TableColumn<DataRow>[] = [
  {
    name: (
      <div className="d-flex align-items-center">
        <i className="bi bi-person-fill text-primary me-2"></i> Nome
      </div>
    ),
    selector: (row) => row.name,
    sortable: true,
  },
  {
    name: (
      <div className="d-flex align-items-center">
        <i className="bi bi-envelope-fill text-info me-2"></i> E-mail
      </div>
    ),
    selector: (row) => row.email,
    sortable: true,
  },
  {
    name: (
      <div className="d-flex align-items-center">
        <i className="bi bi-telephone-fill text-success me-2"></i> Telefone
      </div>
    ),
    selector: (row) => row.number,
    sortable: true,
  },
  {
    name: (
      <div className="d-flex align-items-center">
        <i className="bi bi-building-fill text-primary me-2"></i> Empresa
      </div>
    ),
    selector: (row) => getCompanyTableName(row),
    sortable: true,
    minWidth: "180px",
    maxWidth: "280px",
    style: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      paddingTop: "10px",
      paddingBottom: "10px",
    },
    cell: (row) => (
      <div className="w-100 py-1">
        <span
          className="badge bg-light text-dark d-inline-block w-100 text-start"
          title={getCompanyTableName(row)}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "0.85rem",
            padding: "0.5rem 0.75rem",
          }}
        >
          {getCompanyTableName(row)}
        </span>
      </div>
    ),
  },
  {
           name: <span><i className="bi bi-check-circle-fill me-1
             text-success"></i><span className="text-success fw-bold">Estado</span></span>,
    selector: (row) =>
      row.activeemployee ? (
                <span className="badge bg-success">Ativo</span>
      ) : (
                <span className="badge bg-secondary">Inativo</span>
      ),
    sortable: true,
  },
  ...(canEmployeeEdit ? [{
    name: (
      <span>
        <i className="bi bi-pencil-square me-1 text-primary"></i>
        <span className="text-primary fw-bold">Editar</span>
      </span>
    ),
    cell: (row: { id: number }) => (
      <button         className="btn btn-outline-primary btn-sm"
 onClick={() => handleButtonUpdate(row.id)}>
        <i className="bi bi-pencil-fill"></i>
      </button>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  } as TableColumn<DataRow>] : []),
  ...(masterDataDeleteEnabled && canEmployeeDelete ? [{
    name: (
      <span>
        <i className="bi bi-trash3 me-1 text-danger"></i>
        <span className="text-danger fw-bold">Excluir</span>
      </span>
    ),
    cell: (row: DataRow) => (
      <button
        className="btn btn-outline-danger btn-sm"
        onClick={() => void handleDeleteEmployee(row)}
        disabled={deletingEmployeeId === row.id}
        title="Excluir funcionário"
      >
        <i className={`bi ${deletingEmployeeId === row.id ? "bi-hourglass-split" : "bi-trash3"}`}></i>
      </button>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  } as TableColumn<DataRow>] : [])
];



      
    const handleButtonUpdate = (id: number) => {
        const selectedItem = getData.find((item) => item.id === id);

        stopSignatureCamera();
        photoRequestId.current += 1;
        setSignaturePhotoFile(null);
        setSavedPhotoUrl(null);
        setShowEmployeesFormUpdate(true)
        setFormData({
            id: selectedItem?.id ?? 0,
            name: selectedItem?.name || "",
            email: selectedItem?.email || "",
            cpf: selectedItem?.cpf || "",
            address: selectedItem?.address || "",
            neighborhood: selectedItem?.neighborhood || "",
            postal_code: selectedItem?.postal_code || "",
            city: selectedItem?.city || "",
            state: selectedItem?.state || "",
            number: selectedItem?.number || "",
            house_number: selectedItem?.house_number || "",
            department: selectedItem?.department || "",
            submasterId: submasterId,
            companyId: selectedItem?.companyId || submasterId,
            companyName: selectedItem?.companyName || "",
            companyCnpj: selectedItem?.companyCnpj || "",
            companyImage: selectedItem?.companyImage || "",
            admission_date: selectedItem?.admission_date
            ? new Date(selectedItem?.admission_date).toISOString().split("T")[0]
            : "",
            employeeposition: selectedItem?.employeeposition || "",
            activeemployee: selectedItem?.activeemployee || false
        });
          
          

        console.log(`Item com ID ${id} foi clicado! ${formData?.city}`);
    }
    
    function maskPhone(e: React.ChangeEvent<HTMLInputElement>){
        let phone = e.target.value;
        phone = phone.replace(/\D/g, ''); // Remove tudo o que não é número
        phone = phone.replace(/(\d{2})(\d)/, '($1) $2');
        phone = phone.replace(/(\d{5})(\d{1,4})$/, '$1-$2');
        setFormData({ ...formData, number: phone });
    };

   async function handleChangePostalcode(
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
) {
  const newPostalCode = e.target.value;

  setFormData({
    ...formData,
    postal_code: newPostalCode,
  });

  if (newPostalCode.length === 8) {
    const toastId = toast.info("Buscando CEP...", {
        position: "top-right",
      autoClose: false,
      closeOnClick: false,
      draggable: false,
      closeButton: false,
    });

    try {
      const apiclient = Zip_Code_Api(newPostalCode);
      const response = await apiclient.get("");

      if (response && response.data) {
        if (response.data.erro === "true") {
          throw new Error("CEP não encontrado");
        }

        setFormData((prev) => ({
          ...prev,
          postal_code: newPostalCode,
          neighborhood: response.data.bairro,
          state: response.data.estado,
          city: response.data.localidade,
          address: response.data.logradouro,
        }));

        toast.update(toastId, {
          render: "Endereço encontrado",
          type: "success",
          position: "top-right",
          isLoading: false,
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.update(toastId, {
        render: error.message || "Erro ao buscar o CEP.",
        type: "error",
        isLoading: false,
        position: "top-right",
        autoClose: 3000,
      });
    }
  }
}


    const [filterText, setFilterText] = useState(""); 
    const [backupLoading, setBackupLoading] = useState(false);
    const filteredData = getData.filter(
        (item) =>
            item.email?.toLowerCase().includes(filterText.toLowerCase()) ||
            item.name?.toLowerCase().includes(filterText.toLowerCase())
    );
    const totalEmployees = getData.length;
    const activeEmployees = getData.filter((item) => item.activeemployee).length;
    const filteredEmployees = filteredData.length;

    const formatDate = (date?: string) =>
        date
            ? new Date(date).toLocaleDateString("pt-BR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
              })
            : "";

    const handleBackup = async () => {
        if (backupLoading) {
            return;
        }

        if (filteredData.length === 0) {
            toast.info("Não há funcionários para incluir no backup.");
            return;
        }

        setBackupLoading(true);
        const dateSuffix = formatDateForFileName(new Date());
        const toastId = toast.info(`Gerando backup... 0/${filteredData.length}`, {
            position: "top-right",
            autoClose: false,
            closeOnClick: false,
            draggable: false,
            closeButton: false,
        });

        try {
            const summary = await runPdfOnlyBackup<DataRow>({
                items: filteredData,
                zipRootName: `backup_funcionarios_${dateSuffix}`,
                getLabel: (item) => item.name,
                onProgress: (done, total) => {
                    toast.update(toastId, { render: `Gerando backup... ${done}/${total}` });
                },
                processItem: async (item) => {
                    const pdfFileName = `${sanitizeFileName(item.name)}_funcionario_${item.id}_${dateSuffix}.pdf`;

                    return {
                        pdf: {
                            blob: createSimplePdfBlob(`Cadastro do funcionario - ${item.name}`, [
                                `Nome: ${item.name}`,
                                `E-mail: ${item.email || "Nao informado"}`,
                                `CPF: ${item.cpf || "Nao informado"}`,
                                `Telefone: ${item.number || "Nao informado"}`,
                                `Empresa: ${getCompanyTableName(item)}`,
                                `Setor: ${item.department || "Nao informado"}`,
                                `Cargo: ${item.employeeposition || "Nao informado"}`,
                                `Data de admissao: ${formatDate(item.admission_date) || "Nao informada"}`,
                                `Status: ${item.activeemployee ? "Ativo" : "Inativo"}`,
                            ]),
                            fileName: pdfFileName,
                        },
                    };
                },
            });

            downloadBlob(summary.blob, summary.zipFileName);
            toast.update(toastId, {
                render: `Backup de funcionários concluído com sucesso. ${summary.pdfCount} PDF(s) incluído(s).`,
                type: "success",
                isLoading: false,
                autoClose: 5000,
            });
        } catch (error) {
            console.error("Erro ao gerar backup de funcionários:", error);
            toast.update(toastId, {
                render: "Erro ao gerar o backup dos funcionários.",
                type: "error",
                isLoading: false,
                autoClose: 5000,
            });
        } finally {
            setBackupLoading(false);
        }
    };

    const handleSubmitUpdate = async () => {
        console.log("")


        // Chama a função de validação
        if (!validateFormData(formData)) {
            return;
            }
        if (cameraOpen) {
            toast.warning("Clique em Tirar foto antes de salvar o funcionário.");
            return;
        }
        
            try {
            const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
            const response = await ApiClient.post(`/crud/updatedata/EmployeesSubmaster/${String(formData.id)}`, {
                name: formData.name,
                email: formData.email,
                cpf: formData.cpf,
                address: formData.address,
                neighborhood: formData.neighborhood,
                postal_code: formData.postal_code,
                city: formData.city,
                state: formData.state,
                number: formData.number,
                house_number: formData.house_number,
                department: formData.department,
                admission_date: new Date(formData.admission_date),
                employeeposition: formData.employeeposition,
                ...getSelectedCompanyPayload(),
                activeemployee: formData.activeemployee
            });
        
            // Verifica se a requisição foi bem-sucedida (código HTTP 200-299)
            if (response?.status >= 200 && response.status < 300) {
                if (signaturePhotoAllowed && signaturePhotoFile) {
                    try {
                        await uploadSignaturePhoto(formData.id);
                    } catch (error) {
                        toast.warning("Dados atualizados, mas a foto da assinatura não foi salva. Tente enviar a foto novamente.");
                        return;
                    }
                }
                resetForm();
                toast.success("Atualizado com sucesso! 🎉");
        
                setTimeout(() => {
                window.location.reload();
                }, 1000);
            }else{
                toast.warning("Erro ao editar, por favor verifique os dados como EMAIL OU CPF");
    
            }
            } catch (e) {
                toast.warning("Erro ao editar, por favor verifique os dados como EMAIL OU CPF");
            }

    }
    const resetForm = () => {
        setFormData(getDefaultFormData());
    };
      


    const loadingToast  = () => {
        return toast.info("Processando... aguarde", {
          autoClose: false, 
        })
    };

    const isValidAdmissionDate = (admissionDate: string) => {
        const today = new Date();
        const birthDate = new Date(admissionDate);
        const age = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth() - birthDate.getMonth();
        
        // Se a idade for menor que 15, retorna false
        return age > 15 || (age === 15 && month >= 0);
    };

    // Função de validação
    const validateFormData = (formData: any) => {
        const requiredFields = [
            { key: "name", label: "O nome é obrigatório." },
            { key: "department", label: "O setor é obrigatório." },
            { key: "admission_date", label: "A data de admissão é obrigatória." },
            { key: "employeeposition", label: "O cargo é obrigatório." },
        ];

        for (const field of requiredFields) {
            const value = formData[field.key];
            if (!value || (typeof value === "string" && !value.trim())) {
            toast.error(field.label);
            return false;
            }
        }

        // Validação do CEP (deve conter exatamente 8 dígitos numéricos)
        const cep = formData.postal_code?.replace(/\D/g, "");
        /*if (!cep || cep.length !== 8) {
            toast.error("O CEP deve conter exatamente 8 dígitos.");
            return false;
        }*/

        // Validação da data de admissão (mínimo 15 anos)
        /*if (!isValidAdmissionDate(formData.admission_date)) {
            toast.error("A data de admissão deve ser de um usuário com pelo menos 15 anos.");
            return false;
        }*/

        return true;
    };

    const handleSubmit = async () => {
        console.log("todos os dados... ", formData);
    
        // Chama a função de validação
        if (!validateFormData(formData)) {
        return;
        }
        if (cameraOpen) {
            toast.warning("Clique em Tirar foto antes de salvar o funcionário.");
            return;
        }
    
        try {
        const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
        const response = await ApiClient.post("/crud/create/EmployeesSubmaster", {
            name: formData.name,
            email: formData.email,
            cpf: formData.cpf,
            address: formData.address,
            neighborhood: formData.neighborhood,
            postal_code: formData.postal_code,
            city: formData.city,
            state: formData.state,
            number: formData.number,
            house_number: formData.house_number,
            department: formData.department,
            submasterId: submasterId,
            ...getSelectedCompanyPayload(),
            admission_date: new Date(formData.admission_date),
            employeeposition: formData.employeeposition,
            signature: "",
            biometric_data: "",
            access_permission_request: true,
            activeemployee: formData.activeemployee
        });
    
        // Verifica se a requisição foi bem-sucedida (código HTTP 200-299)
        if (response?.status >= 200 && response.status < 300) {
            if (signaturePhotoAllowed && signaturePhotoFile) {
                const employeeId = Number(response.data?.id);
                try {
                    if (!Number.isInteger(employeeId) || employeeId <= 0) {
                        throw new Error("ID do funcionário não retornado pelo servidor.");
                    }
                    await uploadSignaturePhoto(employeeId);
                } catch (error) {
                    toast.warning("Funcionário cadastrado, mas a foto da assinatura não foi salva. Edite o cadastro para tentar novamente.");
                    setTimeout(() => window.location.reload(), 1800);
                    return;
                }
            }
            resetForm();
            toast.success("Cadastrado com sucesso! 🎉");
    
            setTimeout(() => {
            window.location.reload();
            }, 1000);
        }else{
            toast.warning("Erro ao registrar, por favor verifique os dados como EMAIL OU CPF");

        }
        } catch (e) {
            toast.warning("Erro ao registrar, por favor verifique os dados como EMAIL OU CPF");
        }
    };


    const handlegetActivisionData = async () => {

        const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
        const response = await ApiClient.post("/crud/getdata/EmployeesSubmaster/" + String(localStorage.getId())  + "/false" );
    
        console.log("dados submaster opaa --- ",response.data)
    
    
        const formatdata = response.data.map((item: any) => ({
            name: item.name,
            email: item.email,
            cpf: item.cpf,
            address: item.address,
            neighborhood: item.neighborhood,
            postal_code: item.postal_code,
            city: item.city,
            state: item.state,
            number: item.number,
            house_number: item.house_number,
            department: item.department,
            admission_date: new Date(item.admission_date),
            employeeposition: item.employeeposition,
            id:item.id,
            submasterId: item.submasterId ?? submasterId,
            companyId: Number(
                item.companyId ??
                item.company_id ??
                item.submaster_company_id ??
                item.submasterCompanyId ??
                submasterId
            ),
            companyName:
                item.name_company ??
                item.nameCompany ??
                item.company_name ??
                item.company?.name_company ??
                item.company?.nameCompany ??
                item.submaster_company?.name_company ??
                "",
            companyCnpj:
                item.cnpj_company ??
                item.cnpjCompany ??
                item.company?.cnpj ??
                item.submaster_company?.cnpj ??
                "",
            companyImage:
                item.image_company ??
                item.imageCompany ??
                item.company?.image ??
                item.submaster_company?.image ??
                "",
            activeemployee: item.activeemployee
        }));

        const sortedEmployees = sortEmployeesAlphabetically(formatdata);

        console.log("dados submaster opaa formatdata --- ",sortedEmployees)


        setFormData(formatdata)
        setgetData(sortedEmployees)
    }


    useEffect(() => {
        
        handlegetActivisionData()
        handleGetCompanies()
        handleGetLoggedCompanyName()
        const loadSignaturePhotoPermission = async () => {
            try {
                const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
                const response = await ApiClient.post("/employeeSignaturePhoto/permission", {});
                setSignaturePhotoAllowed(response?.data?.employee_signature_photo_permission_enabled === true);
                setFixedSignatureAllowed(response?.data?.fixed_report_signature_permission_enabled === true);
            } catch (error) {
                console.error("Erro ao consultar permissão da foto da assinatura:", error);
                setSignaturePhotoAllowed(false);
                setFixedSignatureAllowed(false);
            }
        };
        void loadSignaturePhotoPermission();
        const loadMasterDataDeletePermission = async () => {
            try {
                const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
                const response = await ApiClient.post("/reportPermissions", {});
                setMasterDataDeleteEnabled(
                    response?.data?.master_data_delete_permission_enabled === true
                );
            } catch (error) {
                setMasterDataDeleteEnabled(false);
            }
        };
        void loadMasterDataDeletePermission();
    }, []);

    return (
    <LayoutSubmaster>
       <div className="report-config-page management-page">
            {!showEmployeesFormUpdate ? (
                <div>
                    <section className="dashboard-hero report-hero mb-4">
                        <div className="report-hero__content">
                            <span className="pill-badge">Funcionários</span>
                            <h1 className="dashboard-title">Cadastro de funcionários</h1>
                            <p className="dashboard-subtitle">
                                Controle os funcionários cadastrados, acompanhe o status e edite os dados com mais clareza.
                            </p>
                        </div>
                        <div className="d-flex flex-wrap gap-2 epi-hero-actions">
                            <div className="report-hero__badge">
                                <i className="bi bi-person-workspace" />
                                <div>
                                    <span>Painel de colaboradores</span>
                                    <strong>{filteredEmployees} registros visíveis</strong>
                                </div>
                            </div>
                            {canEmployeeCreate && <button className='btn btn-primary epi-primary-action' onClick={() => {
                                resetData()
                                stopSignatureCamera();
                                photoRequestId.current += 1;
                                setSignaturePhotoFile(null);
                                setSavedPhotoUrl(null);
                                setShowFormCreateEmployess(true);
                            }}>
                              <i className="bi bi-person-plus-fill me-2"></i> Cadastrar funcionário
                            </button>}
                            <button
                              className="btn btn-outline-primary epi-primary-action"
                              onClick={handleBackup}
                              disabled={backupLoading}
                            >
                              {backupLoading ? (
                                <span className="spinner-border spinner-border-sm me-2" role="status" />
                              ) : (
                                <i className="bi bi-cloud-download me-2"></i>
                              )}
                              Fazer Backup em PDF
                            </button>
                        </div>
                    </section>

                    <div className="row g-3 mb-4">
                      <div className="col-md-6">
                        <article className="dashboard-card metric-card soft report-metric-card">
                          <div className="metric-card__icon">
                            <i className="bi bi-people fs-4 text-primary" />
                          </div>
                          <div>
                            <p className="metric-card__eyebrow">Funcionários</p>
                            <h2 className="metric-card__value">{totalEmployees}</h2>
                            <p className="metric-card__caption">Registros cadastrados no sistema</p>
                          </div>
                        </article>
                      </div>
                      <div className="col-md-6">
                        <article className="dashboard-card metric-card soft report-metric-card">
                          <div className="metric-card__icon">
                            <i className="bi bi-check2-circle fs-4 text-primary" />
                          </div>
                          <div>
                            <p className="metric-card__eyebrow">Ativos</p>
                            <h2 className="metric-card__value">{activeEmployees}</h2>
                            <p className="metric-card__caption">Funcionários ativos no painel</p>
                          </div>
                        </article>
                      </div>
                    </div>

                    <section className="section-panel report-table-panel">
                      <div className="section-heading">
                        <div>
                          <h3>Tabela de funcionários</h3>
                          <p>Consulte os colaboradores e acesse a edição diretamente pela listagem.</p>
                        </div>
                        <div className="input-group management-search">
                          <span className="input-group-text bg-white">
                            <i className="bi bi-search text-primary"></i>
                          </span>
                          <input
                              type="text"
                              placeholder="Filtrar por funcionário"
                              value={filterText}
                              onChange={(e) => setFilterText(e.target.value)}
                              className="form-control"
                          />
                        </div>
                      </div>

                      <DataTable
                        columns={columns}
                        customStyles={customStyles}
                        data={filteredData}
                        pagination
                        highlightOnHover
                        responsive
                        onSelectedRowsChange={(selected) =>
                            console.log("Selected Rows: ", selected.selectedRows)
                        }
                        paginationComponentOptions={{
                            rowsPerPageText: "Página",
                            rangeSeparatorText: "de",
                            selectAllRowsItem: true,
                            selectAllRowsItemText: "Selecionar todos",
                        }}
                      />
                    </section>
                </div>
            ) :
                    <div className="col-md-12 ">
                     <div className="modal-content shadow-lg epi-modal" 
                     style={{ borderRadius: "1rem", overflow: "hidden" }}>
                            
                                <div
                                    className="modal-header "
                                    style={{ background: "linear-gradient(90deg, #0d6efd, #5dade2)", color: "#fff" }}
                                >
                                    <h5 className="modal-title" style={{ color: "white" }}>
                                        <i className="bi bi-person-plus-fill me-2"></i> Editar Usuário
                                    </h5>
                                </div>
                                <div className="modal-body epi-modal__body">
                                <form method="POST">

                                    {/* Linha 1: Nome e Email */}
                                    <div className="row mb-3">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="name" className="form-label">Nome</label>
                                        <div className="input-group">
                                        <span className="input-group-text bg-white">
                                            <i className="bi bi-person-fill text-primary animate__animated animate__pulse animate__infinite"></i>
                                        </span>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            className="form-control"
                                            placeholder="Nome"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                        </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="email" className="form-label">E-mail</label>
                                        <div className="input-group">
                                        <span className="input-group-text bg-white">
                                            <i className="bi bi-envelope-fill text-success animate__animated animate__pulse animate__infinite"></i>
                                        </span>
                                        <input
                                            type="text"
                                            id="email"
                                            name="email"
                                            className="form-control"
                                            placeholder="E-mail"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                        </div>
                                    </div>
                                    </div>

                                    {/* Linha 2: CPF e Telefone */}
                                    <div className="row mb-3">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="cpf" className="form-label">CPF</label>
                                        <div className="input-group">
                                        <span className="input-group-text bg-white">
                                            <i className="bi bi-credit-card-2-front-fill text-danger animate__animated animate__pulse animate__infinite"></i>
                                        </span>
                                        <input
                                            type="text"
                                            id="cpf"
                                            name="cpf"
                                            className="form-control"
                                            placeholder="CPF"
                                            value={formData.cpf}
                                            onChange={handleChange}
                                            required
                                        />
                                        </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="number" className="form-label">Número de Telefone</label>
                                        <div className="input-group">
                                        <span className="input-group-text bg-white">
                                            <i className="bi bi-telephone-fill text-info animate__animated animate__pulse animate__infinite"></i>
                                        </span>
                                        <input
                                            type="text"
                                            id="number"
                                            name="number"
                                            className="form-control"
                                            placeholder="Número de Telefone"
                                            value={formData.number}
                                            onChange={maskPhone}
                                            required
                                        />
                                        </div>
                                    </div>
                                    </div>

                                    {/* Linha 3: Endereço e Número da Casa */}
                                    <div className="row mb-3">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="address" className="form-label">Endereço</label>
                                        <div className="input-group">
                                        <span className="input-group-text bg-white">
                                            <i className="bi bi-geo-alt-fill text-danger animate__animated animate__pulse animate__infinite"></i>
                                        </span>
                                        <input
                                            type="text"
                                            id="address"
                                            name="address"
                                            className="form-control"
                                            placeholder="Endereço"
                                            value={formData.address}
                                            onChange={handleChange}
                                        />
                                        </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="house_number" className="form-label">Número da Casa</label>
                                        <div className="input-group">
                                        <span className="input-group-text bg-white">
                                            <i className="bi bi-house-door-fill text-warning animate__animated animate__pulse animate__infinite"></i>
                                        </span>
                                        <input
                                            type="text"
                                            id="house_number"
                                            name="house_number"
                                            className="form-control"
                                            placeholder="Número da Casa"
                                            value={formData.house_number}
                                            onChange={handleChange}
                                            required
                                        />
                                        </div>
                                    </div>
                                    </div>

                                    {/* Linha 4: Bairro e CEP */}
                                    <div className="row mb-3">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="neighborhood" className="form-label">Bairro</label>
                                        <div className="input-group">
                                        <span className="input-group-text bg-white">
                                            <i className="bi bi-geo-fill text-info animate__animated animate__pulse animate__infinite"></i>
                                        </span>
                                        <input
                                            type="text"
                                            id="neighborhood"
                                            name="neighborhood"
                                            className="form-control"
                                            placeholder="Bairro"
                                            value={formData.neighborhood}
                                            onChange={handleChange}
                                        />
                                        </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="postal_code" className="form-label">CEP</label>
                                        <div className="input-group">
                                        <span className="input-group-text bg-white">
                                            <i className="bi bi-mailbox2 text-success animate__animated animate__pulse animate__infinite"></i>
                                        </span>
                                        <input
                                            type="text"
                                            id="postal_code"
                                            name="postal_code"
                                            className="form-control"
                                            placeholder="CEP"
                                            value={formData.postal_code}
                                            onChange={handleChangePostalcode}
                                            maxLength={8}
                                            minLength={8}
                                            required
                                        />
                                        </div>
                                    </div>
                                    </div>

                                    {/* Linha 5: Cidade e Estado */}
                                    <div className="row mb-3">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="city" className="form-label">Cidade</label>
                                        <div className="input-group">
                                        <span className="input-group-text bg-white">
                                            <i className="bi bi-building text-warning animate__animated animate__pulse animate__infinite"></i>
                                        </span>
                                        <input
                                            type="text"
                                            id="city"
                                            name="city"
                                            className="form-control"
                                            placeholder="Cidade"
                                            value={formData.city}
                                            onChange={handleChange}
                                        />
                                        </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="state" className="form-label">Estado</label>
                                        <div className="input-group">
                                        <span className="input-group-text bg-white">
                                            <i className="bi bi-flag-fill text-danger animate__animated animate__pulse animate__infinite"></i>
                                        </span>
                                        <input
                                            type="text"
                                            id="state"
                                            name="state"
                                            className="form-control"
                                            placeholder="Estado"
                                            value={formData.state}
                                            onChange={handleChange}
                                        />
                                        </div>
                                    </div>
                                    </div>

                                    {/* Linha 6: Departamento, Cargo e Data de admissão */}
                                    <div className="row mb-3">
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="department" className="form-label">Setor</label>
                                        <div className="input-group">
                                        <span className="input-group-text bg-white">
                                            <i className="bi bi-diagram-3-fill text-info animate__animated animate__pulse animate__infinite"></i>
                                        </span>
                                        <input
                                            type="text"
                                            id="department"
                                            name="department"
                                            className="form-control"
                                            placeholder="Setor"
                                            value={formData.department}
                                            onChange={handleChange}
                                        />
                                        </div>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="employeeposition" className="form-label">Cargo</label>
                                        <div className="input-group">
                                        <span className="input-group-text bg-white">
                                            <i className="bi bi-person-badge-fill text-success animate__animated animate__pulse animate__infinite"></i>
                                        </span>
                                        <input
                                            type="text"
                                            id="employeeposition"
                                            name="employeeposition"
                                            className="form-control"
                                            placeholder="Cargo na empresa"
                                            value={formData.employeeposition}
                                            onChange={handleChange}
                                        />
                                        </div>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="admission_date" className="form-label d-block text-center mt-3">Data de admissão</label>
                                        <div className="input-group">
                                        <span className="input-group-text bg-white">
                                            <i className="bi bi-calendar-fill text-warning animate__animated animate__pulse animate__infinite"></i>
                                        </span>
                                        <input
                                            type="date"
                                            id="admission_date"
                                            name="admission_date"
                                            className="form-control"
                                            value={formData.admission_date}
                                            onChange={handleChange}
                                        />
                                        </div>
                                    </div>
                                    </div>

                                    <div className="row mb-3">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="companyIdUpdate" className="form-label">Empresa</label>
                                        <div className="input-group">
                                        <span className="input-group-text bg-white">
                                            <i className="bi bi-building-fill text-primary animate__animated animate__pulse animate__infinite"></i>
                                        </span>
                                        <select
                                            id="companyIdUpdate"
                                            name="companyId"
                                            className="form-select"
                                            value={formData.companyId || submasterId}
                                            onChange={handleCompanyChange}
                                        >
                                            <option value={submasterId}>{getLoggedCompanyName()}</option>
                                            {companies.map((company) => (
                                                <option key={company.id} value={company.id}>
                                                    {company.name}
                                                </option>
                                            ))}
                                        </select>
                                        </div>
                                    </div>
                                    </div>

                                    {/* Linha 7: Estado do funcionário */}
                                    <div className="row mb-3">
                                    <div className="col-md-12 d-flex justify-content-center align-items-center">
                                        <label className="form-label me-3">
                                        <i className="bi bi-person-check-fill text-success animate__animated animate__pulse animate__infinite me-1"></i> Estado do funcionário
                                        </label>
                                        <div className="form-check form-switch">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="activeemployee"
                                            name="activeemployee"
                                            checked={formData.activeemployee}
                                            onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                activeemployee: e.target.checked,
                                            })
                                            }
                                        />
                                        <label className="form-check-label ms-2" htmlFor="activeemployee">
                                            {formData.activeemployee ? 'Ativo' : 'Inativo'}
                                        </label>
                                        </div>
                                    </div>
                                    </div>

                                    {renderSignaturePhotoField("signaturePhotoUpdate", true)}

                                </form>
                                {/* Rodapé */}
                                <div className="modal-footer">
                                    <button className="btn btn-secondary" onClick={() => {
                                        photoRequestId.current += 1;
                                        stopSignatureCamera();
                                        setSavedPhotoUrl(null);
                                        setSignaturePhotoFile(null);
                                        setShowEmployeesFormUpdate(false);
                                    }}>Fechar</button>
                                    <button
                                        className="btn btn-outline-primary"
                                        onClick={handleSubmitUpdate}
                                    >
                                        <i className="bi bi-check-circle me-2"></i> Salvar Alteração
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
            }
       </div>

       {/* Modal do Bootstrap - Funcionário */}
       {showFormCreateEmployess && (
    <>
    <div className="modal fade show d-block">
        <div className="modal-dialog modal-xl">
          <div className="modal-content shadow-lg ,r epi-modal" 
                     style={{ borderRadius: "1rem", overflow: "hidden" }}>

            {/* Cabeçalho */}
            <div
            className="modal-header animate__animated animate__fadeInDown"
            style={{ background: "linear-gradient(90deg, #0d6efd, #5dade2)", color: "#fff" }}

            >
            <h5 className="modal-title d-flex align-items-center" style={{color:"white"}}>
                <i  style={{color:"white"}} className="bi bi-person-plus-fill me-2 animate__animated animate__bounce animate__infinite"></i>
                Cadastro de Funcionário
            </h5>
            <button  style={{color:"white"}}
                type="button"
                className="btn-close btn-close-white mt-3 mr-3"
                onClick={() => { stopSignatureCamera(); setSignaturePhotoFile(null); setShowFormCreateEmployess(false); }}
            ></button>
            </div>

            {/* Corpo do modal */}
            <div className="modal-body animate__animated animate__fadeInUp epi-modal__body">
            <form method="POST">

                {/* Linha 1: Nome e E-mail */}
                <div className="row mb-3">
                <div className="col-md-6 mb-3">
                    <label htmlFor="name" className="form-label">Nome</label>
                    <div className="input-group">
                    <span className="input-group-text bg-white">
                        <i className="bi bi-person-fill text-primary animate__animated animate__pulse animate__infinite"></i>
                    </span>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Nome completo"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                    </div>
                </div>
                <div className="col-md-6 mb-3">
                    <label htmlFor="email" className="form-label">E-mail</label>
                    <div className="input-group">
                    <span className="input-group-text bg-white">
                        <i className="bi bi-envelope-fill text-success animate__animated animate__pulse animate__infinite"></i>
                    </span>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="seuemail@exemplo.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                    </div>
                </div>
                </div>

                {/* Linha 2: CPF e Telefone */}
                <div className="row mb-3">
                <div className="col-md-6 mb-3">
                    <label htmlFor="cpf" className="form-label">CPF</label>
                    <div className="input-group">
                    <span className="input-group-text bg-white">
                        <i className="bi bi-credit-card-2-front-fill text-danger animate__animated animate__pulse animate__infinite"></i>
                    </span>
                    <input
                        type="text"
                        id="cpf"
                        name="cpf"
                        className="form-control"
                        placeholder="000.000.000-00"
                        value={formData.cpf}
                        onChange={handleChange}
                        required
                    />
                    </div>
                </div>
                <div className="col-md-6 mb-3">
                    <label htmlFor="number" className="form-label">Telefone</label>
                    <div className="input-group">
                    <span className="input-group-text bg-white">
                        <i className="bi bi-telephone-fill text-info animate__animated animate__pulse animate__infinite"></i>
                    </span>
                    <input
                        type="text"
                        id="number"
                        name="number"
                        className="form-control"
                        placeholder="(00) 00000-0000"
                        value={formData.number}
                        onChange={maskPhone}
                        required
                    />
                    </div>
                </div>
                </div>

                {/* Linha 3: CEP e Endereço */}
                <div className="row mb-3">
                <div className="col-md-6 mb-3">
                    <label htmlFor="postal_code" className="form-label">CEP</label>
                    <div className="input-group">
                    <span className="input-group-text bg-white">
                        <i className="bi bi-mailbox2 text-success animate__animated animate__pulse animate__infinite"></i>
                    </span>
                    <input
                        type="text"
                        id="postal_code"
                        name="postal_code"
                        className="form-control"
                        placeholder="00000000"
                        value={formData.postal_code}
                        onChange={handleChangePostalcode}
                        maxLength={8}
                        minLength={8}
                        required
                    />
                    </div>
                </div>
                <div className="col-md-6 mb-3">
                    <label htmlFor="address" className="form-label">Endereço</label>
                    <div className="input-group">
                    <span className="input-group-text bg-white">
                        <i className="bi bi-geo-alt-fill text-danger animate__animated animate__pulse animate__infinite"></i>
                    </span>
                    <input
                        type="text"
                        id="address"
                        name="address"
                        className="form-control"
                        placeholder="Rua, Av..."
                        value={formData.address}
                        onChange={handleChange}
                    />
                    </div>
                </div>
                </div>

                {/* Linha 4: Número e Bairro */}
                <div className="row mb-3">
                <div className="col-md-6 mb-3">
                    <label htmlFor="house_number" className="form-label">Número</label>
                    <div className="input-group">
                    <span className="input-group-text bg-white">
                        <i className="bi bi-house-door-fill text-warning animate__animated animate__pulse animate__infinite"></i>
                    </span>
                    <input
                        type="text"
                        id="house_number"
                        name="house_number"
                        className="form-control"
                        placeholder="Número da casa"
                        value={formData.house_number}
                        onChange={handleChange}
                    />
                    </div>
                </div>
                <div className="col-md-6 mb-3">
                    <label htmlFor="neighborhood" className="form-label">Bairro</label>
                    <div className="input-group">
                    <span className="input-group-text bg-white">
                        <i className="bi bi-geo-fill text-info animate__animated animate__pulse animate__infinite"></i>
                    </span>
                    <input
                        type="text"
                        id="neighborhood"
                        name="neighborhood"
                        className="form-control"
                        placeholder="Bairro"
                        value={formData.neighborhood}
                        onChange={handleChange}
                    />
                    </div>
                </div>
                </div>

                {/* Linha 5: Cidade e Estado */}
                <div className="row mb-3">
                <div className="col-md-6 mb-3">
                    <label htmlFor="city" className="form-label">Cidade</label>
                    <div className="input-group">
                    <span className="input-group-text bg-white">
                        <i className="bi bi-building text-warning animate__animated animate__pulse animate__infinite"></i>
                    </span>
                    <input
                        type="text"
                        id="city"
                        name="city"
                        className="form-control"
                        placeholder="Cidade"
                        value={formData.city}
                        onChange={handleChange}
                    />
                    </div>
                </div>
                <div className="col-md-6 mb-3">
                    <label htmlFor="state" className="form-label">Estado</label>
                    <div className="input-group">
                    <span className="input-group-text bg-white">
                        <i className="bi bi-flag-fill text-danger animate__animated animate__pulse animate__infinite"></i>
                    </span>
                    <input
                        type="text"
                        id="state"
                        name="state"
                        className="form-control"
                        placeholder="Estado"
                        value={formData.state}
                        onChange={handleChange}
                    />
                    </div>
                </div>
                </div>

                {/* Linha 6: Departamento, Cargo e Data de admissão */}
                <div className="row mb-3">
                <div className="col-md-4 mb-3">
                    <label htmlFor="department" className="form-label">Setor</label>
                    <div className="input-group">
                    <span className="input-group-text bg-white">
                        <i className="bi bi-diagram-3-fill text-info animate__animated animate__pulse animate__infinite"></i>
                    </span>
                    <input
                        type="text"
                        id="department"
                        name="department"
                        className="form-control"
                        placeholder="Setor"
                        value={formData.department}
                        onChange={handleChange}
                    />
                    </div>
                </div>
                <div className="col-md-4 mb-3">
                    <label htmlFor="employeeposition" className="form-label">Cargo</label>
                    <div className="input-group">
                    <span className="input-group-text bg-white">
                        <i className="bi bi-person-badge-fill text-success animate__animated animate__pulse animate__infinite"></i>
                    </span>
                    <input
                        type="text"
                        id="employeeposition"
                        name="employeeposition"
                        className="form-control"
                        placeholder="Cargo na empresa"
                        value={formData.employeeposition}
                        onChange={handleChange}
                    />
                    </div>
                </div>
                <div className="col-md-4 mb-3 mt-3">
                    <label htmlFor="admission_date" className="form-label text-center d-block">Data de admissão</label>
                    <div className="input-group">
                    <span className="input-group-text bg-white">
                        <i className="bi bi-calendar-fill text-warning animate__animated animate__pulse animate__infinite"></i>
                    </span>
                    <input
                        type="date"
                        id="admission_date"
                        name="admission_date"
                        className="form-control"
                        value={formData.admission_date}
                        onChange={handleChange}
                    />
                    </div>
                </div>
                </div>

                <div className="row mb-3">
                <div className="col-md-6 mb-3">
                    <label htmlFor="companyIdCreate" className="form-label">Empresa</label>
                    <div className="input-group">
                    <span className="input-group-text bg-white">
                        <i className="bi bi-building-fill text-primary animate__animated animate__pulse animate__infinite"></i>
                    </span>
                    <select
                        id="companyIdCreate"
                        name="companyId"
                        className="form-select"
                        value={formData.companyId || submasterId}
                        onChange={handleCompanyChange}
                    >
                        <option value={submasterId}>{getLoggedCompanyName()}</option>
                        {companies.map((company) => (
                            <option key={company.id} value={company.id}>
                                {company.name}
                            </option>
                        ))}
                    </select>
                    </div>
                </div>
                </div>

                {/* Linha 7: Estado do funcionário */}
                <div className="row mb-3">
                <div className="col-md-12 d-flex justify-content-center align-items-center">
                    <label className="form-label me-3">
                    <i className="bi bi-person-check-fill text-success animate__animated animate__pulse animate__infinite me-1"></i> Estado do funcionário
                    </label>
                    <div className="form-check form-switch">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="activeemployee"
                        name="activeemployee"
                        checked={formData.activeemployee}
                        onChange={(e) =>
                        setFormData({ ...formData, activeemployee: e.target.checked })
                        }
                    />
                    <label className="form-check-label ms-2" htmlFor="activeemployee">
                        {formData.activeemployee ? "Ativo" : "Inativo"}
                    </label>
                    </div>
                </div>
                </div>

                {renderSignaturePhotoField("signaturePhotoCreate", false)}

            </form>
            </div>

            {/* Rodapé */}
            <div className="modal-footer">
            <button
                className="btn btn-secondary"
                onClick={() => { stopSignatureCamera(); setSignaturePhotoFile(null); setShowFormCreateEmployess(false); }}
            >
                Fechar
            </button>
            <button className="btn btn-outline-primary" onClick={handleSubmit}>
                Salvar
            </button>
            </div>
        </div>
        </div>
    </div>

    {/* Background escuro (overlay) */}
    <div className="modal-backdrop fade show"></div>
    </>
       )}

    </LayoutSubmaster>)
}


export default ConfigSubmasterEmployeesPage
